import { state } from './state.js';

export const NO_CONNECTION = 'No connection. Check your connection and try again.';
export const UPLOAD_FAILED = "That photo didn't upload. Check your connection and try again.";

export class ApiError extends Error {
  constructor(status, message) { super(message); this.status = status; }
}

let onUnauthorized = () => {};
export const setUnauthorizedHandler = fn => { onUnauthorized = fn; };
// A 401 while the app thinks it is signed in means the session ended (sign-out elsewhere, removal).
const check401 = status => { if (status === 401 && state.user) onUnauthorized(); };

export async function api(method, path, body) {
  let res;
  try {
    res = await fetch(path, {
      method,
      headers: body === undefined ? {} : { 'Content-Type': 'application/json' },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new ApiError(0, NO_CONNECTION);
  }
  const data = await res.json().catch(() => ({}));
  check401(res.status);
  if (!res.ok) throw new ApiError(res.status, data.error || NO_CONNECTION);
  return data;
}

// Multipart upload with progress (fetch has no upload progress).
export function upload(path, form, onProgress = () => {}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', path);
    xhr.upload.onprogress = e => { if (e.lengthComputable) onProgress(e.loaded / e.total); };
    xhr.onload = () => {
      let data = {};
      try { data = JSON.parse(xhr.responseText); } catch {}
      check401(xhr.status);
      if (xhr.status >= 200 && xhr.status < 300) resolve(data);
      else reject(new ApiError(xhr.status, data.error || UPLOAD_FAILED));
    };
    xhr.onerror = xhr.onabort = xhr.ontimeout = () => reject(new ApiError(0, UPLOAD_FAILED));
    xhr.send(form);
  });
}
